import * as React from 'react'
import { toJS } from 'mobx'
import { observer, inject } from 'mobx-react'
import { withRouter } from 'react-router'
import Form, { ISubmitEvent } from 'react-jsonschema-form'
import LocalizationStore from '../../../Stores/LocalizationStore'
import UsersStore from '../../../Stores/UsersStore'
import UserStore from '../../../Stores/UserStore'
import HttpActionsService from '../../../Services/HttpActionsService'
import UserIsActiveWidget from '../../../Components/UserIsActiveComponent'
import { User, IUser } from '../../../Model/User'
import {
    uiUserEditFormSchema,
    uiUserCreateFormSchema,
    uiUserReadonlyFormSchema,
    validate,
    transformErrors,
    getUserEditFormSchema,
    getUserCreateFormSchema
} from '../../../Model/UserEditForm'
import { ButtonToolbar, Button } from 'react-bootstrap'
import { history } from '../../../Routing'
import UserIsBlockedComponent from '../../../Components/UserIsBlockedComponent'

export interface IUserPageProps {
    match?: object,
    httpActionsService?: HttpActionsService
    userStore?: UserStore
    usersStore?: UsersStore
}

@inject('httpActionsService')
@inject('userStore')
@inject('usersStore')
@observer
class UserPage extends React.Component<IUserPageProps> {

    item: IUser

    schema: any = this.props['match']!['params']['id']
        ? getUserEditFormSchema()
        : getUserCreateFormSchema()
    uiSchema: any = this.props['match']!['params']['id']
        ? uiUserEditFormSchema
        : uiUserCreateFormSchema

    constructor(props: any) {
        super(props)

        const { httpActionsService, usersStore, userStore } = this.props

        if (this.props['match']!['params']['id']) {
            httpActionsService!.getUser(this.props['match']!['params']['id'])
        } else {
            usersStore!.resetUser()
        }

        // TODO: check user roles and permissions
        this.item = usersStore!.getItem

        if (!(userStore!.checkAdmin || userStore!.checkSuperAdmin)) {
            this.uiSchema = uiUserReadonlyFormSchema
        }
    }

    createOrUpdate(e: ISubmitEvent<any>, context: UserPage): void {
        let data: any = {
            user: JSON.parse(JSON.stringify(e.formData))
        }
        let prepareMethod = e['formData'] && e['formData']['id']
            ? 'updateUserFormDataToSubmit'
            : 'createUserFormDataToSubmit'
        data = UsersStore.getInstance()[prepareMethod](data)
        let method = data.user && data.user.id ? 'updateUser' : 'createUser'
        context.props.httpActionsService![method](data)
    }

    cancel() {
        const { userStore } = this.props

        if (
            userStore!.checkAdmin ||
            userStore!.checkCollectionGroupAdministrator ||
            userStore!.checkCreditGroupAdministrator ||
            userStore!.checkSuperAdmin) {
            history.push('/users')
        } else {
            history.push('/')
        }
    }

    checkCreated() {
        return !!this.props['match']!['params']['id']
    }

    checkIsMe(userId?: string): boolean {
        return UserStore.getInstance().id === userId
    }

    resendConfirmaionEmail(e: any, email: string, context: UserPage): void {
        e.preventDefault()
        context.props.httpActionsService!.resendConfirmaionEmail(email)
    }

    render() {
        const self = this
        const ls = LocalizationStore.getInstance()
        const us = UserStore.getInstance()
        const uss = UsersStore.getInstance()

        if (uss.getItem) {
            this.item = toJS(uss.getItem)
        } else {
            this.item = new User()
        }

        this.item = UsersStore.getInstance().updateUserFormDataToShow(this.item)

        return (
            <div className="user row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 blockFormFields">
                    <UserIsActiveWidget
                        user={UsersStore.getInstance().getItem}
                    />
                    <UserIsBlockedComponent
                        user={UsersStore.getInstance().getItem}
                    />
                    <Form
                        schema={this.schema}
                        uiSchema={this.uiSchema}
                        onSubmit={(e) => self.createOrUpdate(e, self)}
                        formData={this.item}
                        validate={validate}
                        transformErrors={transformErrors}
                    >
                        <ButtonToolbar>
                            <div className="credentialsConfirmation">
                                <div className="confirmEmail">
                                    <span>{ls.t('СredentialsConfirmation')}</span>
                                    <Button
                                        hidden={this.item.isEmailConfirmed}
                                        onClick={(e) => this.resendConfirmaionEmail(e, self.item.id, self)}
                                        bsClass="btn-link"
                                    >
                                        {ls.t('resendConfirmaionEmail')}
                                    </Button>
                                </div>
                                <div className="changePassword">
                                    <span>{ls.t('Password')}</span>
                                    <Button
                                        hidden={
                                            !(
                                                us!.checkAdmin ||
                                                us!.checkSuperAdmin ||
                                                this.checkIsMe(this.props['match']!['params']['id'])
                                            )

                                        }
                                        bsClass="btn-link"
                                        href="/changePassword"
                                        className="changePassword"
                                    >
                                        {ls.t('Change password')}
                                    </Button>
                                </div>
                            </div>
                            <div className="submitCancel">
                                <Button
                                    // hidden={us.checkAdmin || us}
                                    type="submit"
                                >
                                    {ls.t!('Save')}
                                </Button>
                                <Button
                                    bsClass="btn btn-secondary"
                                    onClick={() => { self.cancel() }}
                                >
                                    {ls.t!('Cancel')}
                                </Button>
                            </div>
                        </ButtonToolbar>
                    </Form>
                </div>
            </div>
        )
    }
}

export default withRouter(UserPage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Account/UserPage.tsx